import {
  EditEnrollmentInDto,
  EditEnrollmentOutDto,
} from "../../../types/enrollment.dto";

export const UPDATE_ENROLLMENT = "UPDATE_ENROLLMENT";
export const UPDATE_ENROLLMENT_SUCCESS = "UPDATE_ENROLLMENT_SUCCESS";
export const UPDATE_ENROLLMENT_ERROR = "UPDATE_ENROLLMENT_ERROR";
export const RESET_UPDATE_ENROLLMENT = "RESET_UPDATE_ENROLLMENT";

export interface UpdateEnrollment {
  type: typeof UPDATE_ENROLLMENT;
  payload: EditEnrollmentOutDto;
}

export interface UpdateEnrollmentSuccess {
  type: typeof UPDATE_ENROLLMENT_SUCCESS;
  payload: EditEnrollmentInDto;
}

export interface UpdateEnrollmentError {
  type: typeof UPDATE_ENROLLMENT_ERROR;
  payload: string | boolean;
}

export interface ResetUpdateEnrollment {
  type: typeof RESET_UPDATE_ENROLLMENT;
  payload: null;
}

export interface State {
  data: EditEnrollmentInDto | null;
  states: {
    loading: boolean;
    success: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
};

export type Actions =
  | UpdateEnrollment
  | UpdateEnrollmentSuccess
  | UpdateEnrollmentError
  | ResetUpdateEnrollment;
